const NAME = "SYSTEM_AND_USER_TABLES_DEFINITION";

export default NAME;
